import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Gallery from "./components/Gallery";
import ProjectDetails from "./components/ProjectDetails";
import About from "./pages/About";
import Awards from "./pages/Awards";
import Exhibitions from "./pages/Exhibitions";
import Research from "./pages/Research";
import { Toaster } from "./components/ui/toaster";
import SEO from "./components/SEO";
import { DataProvider } from "./context/DataContext";
import { HideEmergentBadge } from "./components/HideEmergentBadge";

const HomePlaceholder = () => (
  <div className="min-h-screen flex flex-col items-center justify-center p-8 opacity-0">
    <SEO /> {/* Default Home SEO */}
    <h1 className="sr-only">Leon Krykhtin - Architect & New Media Artist</h1>
    <p className="sr-only">Leon Krykhtin’s practice exists at the intersection of technology and human experience, exploring the ever-evolving relationship between digital realms and our perception of reality. Through his work in generative art, interactive installations, AI-driven creations, and Virtual Reality experiences, he seeks to blur the boundaries between the virtual and the physical, challenging viewers to reconsider their role in the creative process.</p>
  </div>
);

function App() {
  return (
    <DataProvider>
      <HideEmergentBadge />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePlaceholder />} />
            {/* Explicitly passing category="Film" to the films route as requested */}
            <Route path="films" element={<Gallery category="Film" />} />
            <Route path="generative" element={<Gallery category="Generative" />} />
            <Route path="immersive" element={<Gallery category="Immersive" />} />
            <Route path="awards" element={<Awards />} />
            <Route path="exhibitions" element={<Exhibitions />} />
            <Route path="research" element={<Research />} />
            <Route path="experimental" element={<Gallery category="Experimental" />} />
            <Route path="project/:id" element={<ProjectDetails />} />
            <Route path="about" element={<About />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
